<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">Attachment Details</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <div class="divShadow1">
    <!-- Loader -->
    @if (loadingData) {
<div class="formLoader">
      <i class="fa fa-spinner fa-spin gt-refresh"></i>
    </div>
}

    <!-- Content -->
    @if (!loadingData) {
<div>
      <div class="table-container">
        <table class="info-table">
          <thead>
            <tr>
              <th style="width: 20%;">Basket</th>
              <th style="width: 20%;">Schedule</th>
              <th style="width: 20%;">Country</th>
              <th style="width: 20%;">EIN</th>
              <th style="width: 20%;">Column No.</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ generalInfo.basketName }}</td>
              <td>{{ generalInfo.schdName }}</td>
              <td>{{ generalInfo.country }}</td>
              <td>{{ generalInfo.ein }}</td>
              <td>{{ generalInfo.colNumber }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <br/>

      <div class="results-table-container">
        <table class="results-table">
          <thead>
            <tr>
              <th style="width: 30%;">Gross Inc/Exp</th>
              <th style="width: 30%;">Expense Category</th>
              <th style="width: 20%; text-align:center;">Amount</th>
            </tr>
          </thead>
          <tbody>
            @for (item of resultJson; track $index) {
<tr>
              <td>{{ item.GIE_DESC }}</td>
              <td>{{ item.ALT_GIE_DESC }}</td>
              <td style="text-align: right; padding-right: 30px;"
                  [ngClass]="{'negative-no': isNegativeAmount(item)}">
                {{ item.AMOUNT_FORMATTED }}
              </td>
            </tr>
}
          </tbody>
        </table>
      </div>
    </div>
}
  </div>
</div>
